/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React from "react";
import { useHistory } from "react-router-dom";
import { Menu as SemanticMenu, Container } from "semantic-ui-react";
import {
  isAdminRole,
  isProPlan,
  isStandardPlan,
  isSupportRole,
  isTrial,
} from "../Authenticator/utils";
import styles from "./SubMenu.module.css";

interface SubMenuProps {
  sessionInfo: any;
}

const SubMenu: React.FC<SubMenuProps> = ({ sessionInfo }) => {
  const history = useHistory();
  const { pathname } = history.location;
  const { role = "", plan = "" } = sessionInfo;

  const subMenuItem = (name: string, path: string, extraProps?: any) => {
    return (
      <SemanticMenu.Item
        className={
          pathname === path ? styles.subMenuItemActive : styles.subMenuItem
        }
        active={pathname === name}
        name={name}
        onClick={() => {
          history.push(path);
        }}
        {...extraProps}
      />
    );
  };

  return (
    <Container className={styles.subMenuItemContainer}>
      <SemanticMenu stackable pointing secondary id={styles.subMenu}>
        {subMenuItem("Profile", "/MyAccount")}
        {subMenuItem("Company", "/Company")}
        {role !== "USER" && subMenuItem("Billing", "/Billing")}
        {(isStandardPlan(plan) || isProPlan(plan)) &&
          isAdminRole(role) &&
          subMenuItem("Contacts", "/Contacts")}
        {(isTrial(plan) || isProPlan(plan)) &&
          isAdminRole(role) &&
          subMenuItem("Developer", "/Developer")}
        {isSupportRole(role) &&
          subMenuItem("Manage", "/Manage", { position: "right" })}
      </SemanticMenu>
    </Container>
  );
};

export default SubMenu;
